import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider as ConfigProviderAntd } from "antd";
import App from "../initialpage/App";
import config from "config";
import "font-awesome/css/font-awesome.min.css";

import "../assets/css/font-awesome.min.css";
import "../assets/css/line-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Custom Style File
import "../assets/js/bootstrap.min.js";
import "../assets/css/style.css";
import "../assets/js/popper.min.js";
import "../assets/js/app.js";
import "../assets/js/jquery.slimscroll.min.js";
import "../assets/js/jquery-ui.min.js";
// import "../assets/js/telerikReportViewer-19.0.25.211.js";
// import "../assets/js/telerikReportViewer-19.0.25.211.min.js";
// import "../assets/js/telerikReportViewer.kendo-15.2.21.915.min.js";
// import "../assets/css/telerikReportViewer-15.2.21.915.css";
// import "../assets/js/telerikReportViewer.kendo-15.2.21.915.min.js";

import "../assets/css/telerikReportViewer-19.3.26.121.min.css";
import "../assets/js/telerikReportViewer.kendo-19.3.26.121.min.js";
import "../assets/js/telerikReportViewer-19.3.26.121.js";
import "../assets/js/telerikReportViewer-19.3.26.121.min.js";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/react-sortable-tree.css";

// css to fix telerik email editor
import "../assets/css/telerik-override.css";
import "@xyflow/react/dist/style.css";
import "../assets/css/customCss.css";

// const getBasename = path => path.substr(0, path.lastIndexOf('/'));
// console.log('sreevidsf '+" "+getBasename)
const MainApp = () => {
  return (
    <Router basename={`${config.publicPath}`}>
      <ConfigProviderAntd
        theme={{
          components: {
            Timeline: {
              dotBg: "#F0F0F0",
            },
          },
        }}
      >
        <App />
      </ConfigProviderAntd>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
    </Router>
  );
};

export default MainApp;
